import { Box, Button, CircularProgress, Flex, Image, Input, Text } from '@chakra-ui/react'
import Chip from './Chip'
import { useEffect } from 'react'
import { getTypeLabel } from './ListItem'

const Header = ({searchInputRef, searchText, onSearchTextChange, question, isLoading, clearQuestion, filter, clearFilter, filterTo}) => {
  // useEffect(() => console.log(filterTo), [filterTo])
  
  if (isLoading) {
    return (
      <>
        <Flex mx='24px' flexShrink={0} alignItems='center'>
          <Text 
            color='#222222'
            fontWeight='500'
            py='25px'
            mr='24px'
            px={0}
            border='none'
            lineHeight='19px' 
            fontSize='16px'
          >
            Working on it...
          </Text>
          <CircularProgress ml='auto' isIndeterminate color='#A423A9' size={5} />
        </Flex>
        <Box w='full' bg='#E0E0E0' h='0.5px' />
      </>
    )
  }
  
  if (question) {
    return (
      <>
        <Flex mr='24px' ml='16px' flexShrink={0} alignItems='center'>
          <Input ref={searchInputRef} minW={0} w={0} autoFocus p={0} m={0} />
          <Button
            p={0}
            h='32px'
            w='32px'
            color='brandTextBlack'
            borderRadius='6px'
            colorScheme='brandWhite'
            minW={0}
            onClick={clearQuestion}
            // bg={dateFilter ? '#EFF0F7' : 'initial'}
            // border={dateFilter ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid #FBFBFB'}
          >
            <Image boxSize={4} color='brandTextBlack' src='/assets/icons/arrowBack.svg' />
          </Button>
          {filter && filter.id ? (
            <>
              <Box ml='4px' />
              <Chip type={filter.type} label={filter.label} subLabel={filter.subLabel} />  
            </>
          ) : <></>}
          <Text 
            color='#222222'
            fontWeight='500'
            py='25px'
            ml='12px'
            mr='24px'
            px={0}
            border='none'
            lineHeight='19px' 
            fontSize='16px'
          >
            {question}
          </Text>
        </Flex>
        <Box w='full' bg='#E0E0E0' h='0.5px' />
      </>
    )
  }
  
  return (
    <>
      <Flex flexShrink={0}>
        <Box ml='18px' />
        {filter && filter.id ? (
          <Chip type={filter.type} label={filter.label} subLabel={filter.subLabel} />
        ) : <></>}
        
        <Input 
          color='#222222'
          fontWeight='500'
          py='20px'
          mr='24px'
          ml={2}
          px={0}
          h='auto'
          border='none'
          value={searchText}
          lineHeight='19px' 
          fontSize='16px'
          onChange={onSearchTextChange}
          placeholder='Search or type a command...'
          onKeyDown={e => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault()
            }
            if (e.key === 'Backspace' && !searchText) {
              clearFilter()
            }
          }}
          
          ref={searchInputRef} 
        />

        {/* {!(filter && filter.id) && filterTo && filterTo.id ? (
          
          <Flex
            alignItems='center'
            alignSelf='center'
            flexShrink={0}
          >
            <Text color='#222222' opacity='0.6' fontSize='14px' lineHeight='17px' fontWeight='500'>
              {'Filter To'}
              &nbsp;
              {filterTo.label}
              {filterTo.subLabel ? (
                <>
                  &nbsp;
                  <Box as='span' color='#878A95' opacity='0.6'>
                    {filterTo.subLabel}
                  </Box>
                  
                </>
              ): <></>}
              &nbsp;
              <Box as='span' color='#878A95' opacity='0.6'>
                {getTypeLabel(filterTo.type)}
              </Box>
            </Text>
            <Flex
              bg='#F5F7F9'
              w='42px'
              h='28.5px'
              ml='12px'
              alignItems='center'
              justifyContent='center'
              borderRadius='4.6px'
            >
              <Text
                color='#898A93'
                fontWeight='700'
                fontSize='12px'
                lineHeight='16px'
                letterSpacing='0.08em'
                textTransform='uppercase'
              >
                TAB
              </Text>
            </Flex>
          </Flex>
        ) : <></>} */}

        <Box ml='18px' />
      </Flex>
      <Box w='full' bg='#E0E0E0' minH='0.5px' />
    </>
  )
}

export default Header